import React from 'react';
import {Shimmer} from "./index";

const ActualityShimmer = () => (
    <div className="container mx-auto p-8">
        <Shimmer className="h-8 w-48 mb-6 rounded"/>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((item) => (
                <div key={item} className="rounded-lg overflow-hidden">
                    <Shimmer className="w-full h-48"/>
                    <div className="p-4">
                        <Shimmer className="h-6 w-3/4 mb-3 rounded"/>
                        <Shimmer className="h-4 w-full mb-2 rounded"/>
                        <Shimmer className="h-4 w-2/3 rounded"/>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default ActualityShimmer;